const SIGNIN_START_EVENT = {
    name: 'signin.start',
    data: {
        event: {
            category: 'signin',
            action: 'start',
            subcategory: 'NON-OTSI',
        },
    },
};

const SIGNIN_COMPLETION_EVENT = {
    name: 'signin.complete',
    data: {
        event: {
            category: 'signin',
            action: 'complete',
            subcategory: 'NON-OTSI',
        },
    },
};

const SIGNIN_MAGIC_LINK_COMPLETION_EVENT = {
    name: 'signin.complete',
    data: {
        event: {
            category: 'signin',
            action: 'complete',
            subcategory: 'MAGIC-LINK',
        },
    },
};

export {
    SIGNIN_START_EVENT,
    SIGNIN_COMPLETION_EVENT,
    SIGNIN_MAGIC_LINK_COMPLETION_EVENT,
};
